module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Recent Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Virtual Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Planet Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Buck Wild Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Duke 2000: Whatever It Takes")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Revolt of the English Majors")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Peace Out, Dawg!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Got War?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Talk to the Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Heckuva Job, Bushie!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Welcome to the Nerd Farm!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Tee Time in Berzerkistan")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Red Rascal’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Squared Away")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Weed Whisperer")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yuge!: 30 Years of Doonesbury on Trump")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("#SAD!: Doonesbury in the Time of Trump")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Anthologies")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Doonesbury Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Doonesbury’s Greatest Hits")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The People’s Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Doonesbury Dossier: The Reagan Years")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Doonesbury Deluxe: Selected Glances Askance")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Recycled Doonesbury: Second Thoughts on a Gilded Age")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Portable Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Bundled Doonesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("40: A Doonesbury Retrospective")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Special Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Flashbacks: Twenty-Five Years of Doonesbury ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Action Figure!: The Life and Times of Doonesbury’s Uncle Duke")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Dude: The Big Book of Zonker")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Sandbox: Dispatches from Troops in Iraq and Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The War in Quotes")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“My Shorts R Bunching. Thoughts?”: The Tweets of Roland Hedley")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Wounded Warrior Series")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Long Road Home: One Step at a Time")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The War Within: One More Step at a Time")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Signature Wound: Rocking TBI")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Mel’s Story: Surviving Military Sexual Assault")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4754d19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LEWSER_epub-1.vue
// module id = 60
// module chunks = 0